<div class="card" *blockUI="'section-block'">
  <div class="row mt-1">
    <!-- Teklif Ekle Butonu -->
    <a class="ml-2" href="#/admin/create-offer" *ngIf="authService.isEndpointStatus('POST.Writing.CreateTransactions')">
      <button class="btn btn-primary" rippleEffect>
        <i data-feather="plus" class="d-sm-none d-inline-block"></i>
        <span class="d-none d-sm-inline-block">Teklif Ekle</span>
      </button>
    </a>

    <!-- Firma Seçimi -->
    <div class="form-group col-md-2 col-sm-12">
      <ng-select [items]="companies" name="selectedPlan" bindLabel="companyName" bindValue="id" placeholder="Firma Seç"
        (change)="filterByCompany($event)" [(ngModel)]="companyId" [clearable]="false">
      </ng-select>
    </div>

    <!-- Durum Seçimi -->
    <div class="form-group col-md-2 col-sm-12">
      <ng-select [items]="statusList" name="selectedRole" bindLabel="title" bindValue="id" placeholder="Durum"
        (change)="filterByStatus($event)" [(ngModel)]="status" [clearable]="false">
      </ng-select>
    </div>

    <!-- Tarih Aralığı Seçimi -->
    <div class="form-group col-md-3 col-sm-12">
      <div class="input-group">
        <input name="datepicker" class="form-control" ngbDatepicker #datepicker="ngbDatepicker"
          placeholder="yyyy-mm-dd - yyyy-mm-dd" [value]="displayDateRange()" (click)="datepicker.toggle()"
          (dateSelect)="onDateSelection($event)" [autoClose]="'outside'" [dayTemplate]="rangeSelectionDP"
          outsideDays="hidden" [startDate]="fromDate!" />
        <ng-template #rangeSelectionDP let-date let-focused="focused">
          <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
            [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
            (mouseleave)="hoveredDate = null">
            {{ date.day }}
          </span>
        </ng-template>
        <div class="input-group-append">
          <button class="btn btn-outline-secondary feather icon-calendar" (click)="datepicker.toggle()"
            type="button"></button>
        </div>
      </div>
    </div>

    <!-- Arama Kutusu -->
    <div class="form-group col-md-2 col-sm-12">
      <label class="d-flex align-items-center">
        <input type="search" placeholder="Bul" class="form-control" (keyup)="filterUpdate($event)"
          (search)="filterUpdate($event)" />
      </label>
    </div>

    <div>
      <button type="button" class="btn btn-icon btn-outline-primary" rippleEffect (click)="clearFilters()">
        <span [data-feather]="'trash'"></span>
      </button>
    </div>

    <label class="ml-3">
      <select class="form-control" [(ngModel)]="basicSelectedOption" (ngModelChange)="onOptionChange()">
        <option value="5">5</option>
        <option value="10">10</option>
        <option value="15">15</option>
        <option value="50">50</option>
      </select>
    </label>
  </div>

  <ngx-datatable [rows]="rows" [rowHeight]="50" class="bootstrap core-bootstrap" style="cursor: pointer;" [messages]="{ 
    emptyMessage: 'Veri Yok',
    totalMessage: 'Toplam', 
    selectedMessage: 'Seçili'
  }" [limit]="selectedSize" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" [scrollbarH]="true"
    rowHeight="auto" (activate)="onActivate($event)">
    <ng-template ngx-datatable-cell-template let-row="row">
      <a href="#/admin/detail-product/{{row.id}}">{{row.name}}</a>
    </ng-template>

    <ngx-datatable-column name="Teklif No" prop="no" [width]="100"></ngx-datatable-column>
    <ngx-datatable-column name="Teklif Verilen Firma Adı" prop="companyName" [width]="350">
      <ng-template ngx-datatable-cell-template let-row="row">
        <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
          {{ row.companyName }}
        </div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Bitiş Tarihi" [width]="200">
      <ng-template ngx-datatable-cell-template let-row="row">
        {{row.validtiyDate | date: 'dd.MM.yyyy'}}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Durumu" [width]="200">
      <ng-template ngx-datatable-cell-template let-row="row">
        <div [ngClass]="getStatusClass(row.status)" class="align-items-center">
          {{ getStatusText(row.status) }}
        </div>
      </ng-template>
    </ngx-datatable-column>

    <!-- <ngx-datatable-column [width]="40" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div ngbDropdown container="body">
                  <button ngbDropdownToggle type="button" class="btn icon-btn btn-sm hide-arrow" rippleEffect>
                    <span [data-feather]="'more-vertical'" [class]="'cursor-pointer'"></span>
                  </button>
                  <div ngbDropdownMenu>
                    <a href="#/admin/company/{{row.id}}" ngbDropdownItem
                      class="d-flex align-items-center"><i data-feather="file-text" class="mr-50"></i>Görüntüle</a>
                     <a href="javascript:;" ngbDropdownItem
                        ><span [data-feather]="'trash'" [size]="16" [class]="'mr-50'"></span> Delete</a
                      > 
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column> -->
    <ngx-datatable-footer>
      <ng-template ngx-datatable-footer-template>
        <div class="datatable-footer-inner">
          <div class="page-count">
            Toplam Veri {{ totalCount }}
          </div>
          <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10" [(page)]="pageBasic"
            (pageChange)="onPageChange($event)" [maxSize]="5">
            <ng-template ngbPaginationPrevious><span [data-feather]="'chevron-left'" [size]="18"
                [class]="'font-weight-bolder'"></span>
            </ng-template>
            <ng-template ngbPaginationNext><span [data-feather]="'chevron-right'" [size]="18"
                [class]="'font-weight-bolder'"></span></ng-template>
          </ngb-pagination>
        </div>
      </ng-template>
    </ngx-datatable-footer>
  </ngx-datatable>
</div>